'use client';

import Txt, { TxtProps } from '../ui/Txt';

type RelevantAreaTitle = TxtProps<
  'h5',
  {
    title?: string;
  }
>;

const RelevantAreaTitle = ({ title }: RelevantAreaTitle) => {
  return (
    <Txt as="h5" variant="h5" cx={{ mB: { xs: 'sm', lg: 'lg' } }}>
      {title}
    </Txt>
  );
};

export default RelevantAreaTitle;
